import type { AppQueryConfig } from "QueryTypes";
import type { SimulatorState, SimulatorStateJsonReponse } from "Models";
import { normalize } from "normalizr";
import { simulatorState } from "./simulatorStateSchema";
import type { EntitiesById } from "StoreTypes";
import { clubhouseApiHeadersV1 } from "utils/api/apiHelper";
import { timerStringToTimerArray } from "utils/timer/timerHelpers";
import { config } from "@/config/env";

const urls = {
  simulatorState(simId: string): string {
    return `${config.apiBaseUrl}/api/simulators/${simId}/state`;
  },
};

/**
 * One simulator's current state.
 *
 * `force` re-requests a query redux-query already considers fulfilled. A
 * caller that is about to act on the answer — sending a round to this bay —
 * needs the bay's state now, not the copy taken when the picker opened;
 * without it, a "re-check" can resolve from cache and confirm the very
 * staleness it exists to catch.
 */
export const getSimulatorStateQuery = (
  simId: string,
  { force = false }: { force?: boolean } = {},
): AppQueryConfig => ({
  url: urls.simulatorState(simId),
  queryKey: `getSimulatorState:${simId}`,
  force,
  options: { ...clubhouseApiHeadersV1() },
  transform: (responseJson: SimulatorStateJsonReponse) => {
    const responseJsonTimerUpdated = {
      ...responseJson,
      ...{ timerValue: timerStringToTimerArray(responseJson.timerValue) },
    };
    return normalize(responseJsonTimerUpdated, simulatorState).entities;
  },
  update: {
    simulatorStates: (oldValue, newValue): EntitiesById<SimulatorState> => ({
      ...oldValue,
      ...newValue,
    }),
  },
});
